import { createAction } from 'redux-actions';

export const setCampId = createAction('SET_CAMP_ID');
export const setPlans = createAction('SET_PLANS');
export const setStayPlans = createAction('SET_STAY_PLANS');
export const setCourses = createAction('SET_COURSES');
export const setPayments = createAction('SET_PAYMENTS');
export const setRentals = createAction('SET_RENTALS');
export const setPcTypes = createAction('SET_PC_TYPES');
export const setPrices = createAction('SET_PRICES');
export const setSchoolNames = createAction('SET_SCHOOL_NAMES');
export const setLoadingSchoolNames = createAction('SET_LOADING_SCHOOL_NAMES');
export const setPeymentId = createAction('SET_IS_PEYMENT_ID');
export const setPlanStayplanMeetingTimes = createAction('SET_PLAN_STAYPLAN_MEETING_TIMES');

// saga
export const SAGA_INITIALZE_CAMP_FORM = 'SAGA_INITIALZE_CAMP_FORM';
export const SAGA_GET_STAY_PLANS = 'SAGA_GET_STAY_PLANS';
export const SAGA_GET_COURSES = 'SAGA_GET_COURSES';
export const SAGA_GET_PLAN_STAYPLAN_MEETING_TIMES = 'SAGA_GET_PLAN_STAYPLAN_MEETING_TIMES';
export const SAGA_GET_PAYMENTS = 'SAGA_GET_PAYMENTS';
export const SAGA_GET_RENTALS = 'SAGA_GET_RENTALS';
export const SAGA_GET_PRICES = 'SAGA_GET_PRICES';
export const SAGA_IS_COUPON_ERROR_EXIST = 'SAGA_IS_COUPON_ERROR_EXIST';
